import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';

const SVGWrap = styled.div`
height: 28px;

svg {
    height: 100%;
    width: auto;
}
svg:not(.active) {
    filter: brightness(1.8) grayscale(1) opacity(.7);
}
svg:hover {
    filter: brightness(1.2) grayscale(.5) opacity(.9);
}
`;

export default ({ active }: { active?: boolean}) => (
    <SVGWrap>
        <svg viewBox="0 0 27 22" className={cx({active})}>
            <defs>
                <polygon id="path-1" points="0 0.5321 26.4238759 0.5321 26.4238759 21 0 21" />
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-52.000000, -448.000000)">
                    <g transform="translate(52.000000, 448.000000)">
                        <path d="M9.2086,20.4103 L1.0576,12.2583 C0.9796,12.1813 0.9796,12.0553 1.0576,11.9773 L3.2176,9.8183 C3.2946,9.7413 3.4196,9.7413 3.4966,9.8183 L9.2066,15.5273 C9.2846,15.6043 9.4096,15.6043 9.4866,15.5273 L22.9256,2.0573 C23.0026,1.9803 23.1276,1.9803 23.2046,2.0573 L25.3656,4.2153 C25.4436,4.2923 25.4436,4.4173 25.3666,4.4943 L9.4886,20.4103 C9.4116,20.4873 9.2866,20.4873 9.2086,20.4103" id="Fill-1" fill="#9DCD64" />
                        <g transform="translate(0.000000, 0.468100)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1" />
                            </mask>
                            <path d="M23.065,0.5321 C22.745,0.5321 22.444,0.6571 22.217,0.8841 L9.346,13.7841 L4.204,8.6431 C3.978,8.4171 3.677,8.2921 3.357,8.2921 C3.037,8.2921 2.736,8.4171 2.509,8.6431 L0.35,10.8031 C-0.117,11.2691 -0.117,12.0291 0.35,12.4971 L8.502,20.6491 C8.728,20.8761 9.029,21.0001 9.349,21.0001 C9.669,21.0001 9.97,20.8751 10.197,20.6481 L26.075,4.7331 C26.541,4.2651 26.54,3.5061 26.073,3.0391 L23.912,0.8821 C23.685,0.6561 23.384,0.5321 23.065,0.5321 M23.065,1.5321 C23.116,1.5321 23.167,1.5521 23.205,1.5901 L25.366,3.7471 C25.444,3.8241 25.444,3.9491 25.367,4.0261 L9.489,19.9421 C9.451,19.9801 9.4,20.0001 9.349,20.0001 C9.298,20.0001 9.248,19.9801 9.209,19.9421 L1.057,11.7901 C0.98,11.7131 0.98,11.5871 1.057,11.5101 L3.216,9.3501 C3.255,9.3111 3.306,9.2921 3.357,9.2921 C3.408,9.2921 3.459,9.3111 3.497,9.3501 L9.207,15.0591 C9.246,15.0971 9.296,15.1171 9.347,15.1171 C9.398,15.1171 9.449,15.0971 9.487,15.0591 L22.925,1.5901 C22.963,1.5521 23.014,1.5321 23.065,1.5321" id="Fill-3" fill="#168C44" mask="url(#mask-2)" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </SVGWrap>
);